import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProductDetailHero from '../components/ProductDetailHero';
import ProductInfo from '../components/ProductInfo';
import ProductInfoSimple from '../components/ProductInfoSimple';
import CustomOptionsGallery from '../components/CustomOptionsGallery';
import ImageGallery from '../components/ImageGallery';
import AdditionalInfo from '../components/AdditionalInfo';
import { productData } from '../data/productData';

const ProductDetailPage = ({ onGetQuoteClick }) => {
  const { productId } = useParams();
  const product = productData[productId];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [productId]);

  if (!product) {
    return (
      <main id="product-detail-main" className="mt-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 text-center">
          <h1 className="text-2xl font-bold text-premium-dark">Product not found</h1>
        </div>
      </main>
    );
  }

  const isSimpleLayout = product.layoutType === 'simple';

  return (
    <main id="product-detail-main" className="mt-20 bg-white">
      <ProductDetailHero 
        mainImage={product.mainImage}
        alt={product.alt}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="mb-8"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
          {isSimpleLayout ? (
            <>
              <ProductInfoSimple
                series={product.series}
                title={product.title}
                description={product.description}
                onGetQuoteClick={onGetQuoteClick}
              />
              <ImageGallery 
                images={product.imageGallery?.images || []}
                title={product.imageGallery?.title}
              />
            </>
          ) : (
            <>
              <ProductInfo
                series={product.series}
                title={product.title}
                specifications={product.specifications}
                description={product.description}
                onGetQuoteClick={onGetQuoteClick}
              />
              <CustomOptionsGallery sections={product.customOptionsSections} />
            </>
          )}
        </div>
        <AdditionalInfo items={product.additionalInfoItems} />
      </div>
    </main>
  );
};

export default ProductDetailPage;
